import Vue from 'vue'
import numeral from 'numeral'
import { priceFormat } from '@/utils/utils'
import { PRODUCT_STATUS } from '@/enums/status.enum'
import dayjs from '@/helpers/dayjs'

Vue.filter('currency', (val) => numeral(val).format('0,0.00'))
Vue.filter('comma', (val) => numeral(val).format('0,0'))

Vue.filter('currencyTh', (val) => priceFormat(val))
Vue.filter('productType', (val) => PRODUCT_STATUS[val])
Vue.filter('dateTh', (val) => dayjs(val).format('DD/MM/YYYY HH:mm'))
Vue.filter('dateZoneTh', (val) =>
  dayjs(val).format('YYYY-MM-DD HH:mm:ss'),
)
